// components/auth/AuthFormWrapper.tsx
import { motion } from 'framer-motion'
import {
	fadeIn,
	prefersReducedMotion,
	slideUp,
	staggerContainer,
} from '#app/utils/animations'
import { cn } from '#app/utils/misc'

export function AuthFormWrapper({
	title,
	subtitle,
	children,
	titleClassName,
	subtitleClassName,
	containerClassName,
	headerAction,
}: {
	title: string
	subtitle?: string
	children: React.ReactNode
	titleClassName?: string
	subtitleClassName?: string
	containerClassName?: string
	headerAction?: React.ReactNode
}) {
	const shouldAnimate = !prefersReducedMotion()

	return (
		<div
			className={cn(
				'p-[20px_20px] w-full max-w-full md:max-w-[80%]',
				containerClassName,
			)}
		>
			<motion.div
				className="text-left"
				initial={shouldAnimate ? 'hidden' : false}
				animate={shouldAnimate ? 'visible' : false}
				variants={staggerContainer}
			>
				{/* Header row */}
				<div className="flex flex-col gap-5 mb-[12px] md:mb-[18px]">
					{headerAction && <div>{headerAction}</div>}

					<motion.h1
						variants={shouldAnimate ? slideUp : undefined}
						className={cn(
							'text-h1 text-[24px] uppercase text-[#32302F]',
							titleClassName,
						)}
					>
						{title}
					</motion.h1>
				</div>

				{subtitle && (
					<motion.p
						variants={shouldAnimate ? fadeIn : undefined}
						className={cn('text-[14px] text-[#969696]', subtitleClassName)}
					>
						{subtitle}
					</motion.p>
				)}
			</motion.div>

			<motion.div
				className="mt-[30px] max-w-[560px]"
				initial={shouldAnimate ? 'hidden' : false}
				animate={shouldAnimate ? 'visible' : false}
				variants={shouldAnimate ? slideUp : undefined}
				transition={{ delay: 0.2 }}
			>
				{children}
			</motion.div>
		</div>
	)
}
